/**
 * Add-Ons / Rent Reporting (Credit Path) visibility.
 * Set REACT_APP_RENT_REPORTING_ENABLED=true in web/.env — rebuild required for CRA.
 */
export function isRentReportingFeatureEnabled() {
  return String(process.env.REACT_APP_RENT_REPORTING_ENABLED || '')
    .toLowerCase()
    .trim() === 'true';
}

/** When true, home tile shows Launch + launch URL (company subscribed); otherwise Enroll + enroll URL */
export function isRentReportingClientSubscribed() {
  return String(process.env.REACT_APP_RENT_REPORTING_ENROLLED || '')
    .toLowerCase()
    .trim() === 'true';
}
